module.exports = __webpack_public_path__ + "img/docfords.f9df2301.jpg";